import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const panelTypeService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
};

const MODULE = {
    PANEL_TYPE: 'panel-types',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PANEL_TYPE}`, request);
}

export function store (data) {
    const request = {
        name: data.name,
    };

    return apiHelper(API_URL).post(`/${MODULE.PANEL_TYPE}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PANEL_TYPE}/${uuid}`);
}

export function update (data) {
    const request = {
        name: data.name,
    };

    return apiHelper(API_URL).put(`/${MODULE.PANEL_TYPE}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PANEL_TYPE}/${data.uuid}`, request);
}